const actionsTypes = {
  SET_THREADS: 'SET_THREADS',
  SET_LABELS: 'SET_LABELS',
  SET_IS_THREAD_CHECKED: 'SET_IS_THREAD_CHECKED',
  SET_CLIENT_STATUS: 'SET_CLIENT_STATUS',
  SET_UNREAD_QUANTITY: 'SET_UNREAD_QUANTITY',
};

export default actionsTypes;
